import { Component, OnInit } from '@angular/core';
import {HelperService} from '../../shared/services/helper.service';
import {ApiServices} from '../../shared/services/api.service';
import {ActivatedRoute} from '@angular/router';

import { Meta, Title } from '@angular/platform-browser';
import {MetaService} from '../../shared/services/meta.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
	
	pageData: any;
  title: any;
  body: any;
  metaTags:any;
 

  constructor(private helperService: HelperService, private activatedRoute: ActivatedRoute, private apiServices:ApiServices, private meta: Meta, private metaService: MetaService) {
    this.title = "Privacy Policy";
    this.body = '<section class="ny-text-section">';
      this.body += '<div class="container-fluid">';
        this.body += '<div class="row">';
          this.body += '<div class="col-md-12">';
            this.body += '<div class="ny-confirmation">';
              this.body += '<img src="assets/img/n-false.png" alt="img" />';
              this.body += '<h1>Sorry,</h1>';
              this.body += '<p>Page not found!</p>';
            this.body += '</div>';
          this.body += '</div>';
        this.body += '</div>';
      this.body += '</div>';
    this.body += '</section>';

    helperService.setPageTitle(activatedRoute.snapshot.data.title);
    this.metaTags = meta;

  }

  ngOnInit(): void {
    this.getPageData();
    this.metaService.updateCanonicalURL();
  }

  getPageData() {
    this.apiServices.getPrivacyPolicy().subscribe(response => {
      if(response.status == true){
        this.pageData = response.data;
        this.title = response.data.title;
        this.body = response.data.body;

        this.meta.updateTag({ name: 'title', content: response.data.meta_title});
        this.meta.updateTag({ name: 'keywords', content: response.data.meta_keywords});
        this.meta.updateTag({ name: 'description', content: response.data.meta_description});

      }
    });
  }

}
